import Hotel from 'material-react-icons/Hotel';
import React, { FC, HTMLAttributes } from 'react';
import classNames from '../../helpers/classNames';
import useTranslate from '../../hooks/useTranslate';
import { AccommodationItemType } from '../../services/apis/accommodation/types';
import Button from '../Button/Button';
import FormattedCurrency from '../FormattedCurrency/FormattedCurrency';
import { IconDrop, IconPlug, IconPlus } from '../Icons/Icons';
import Tooltip from '../Tooltip/Tooltip';
import styles from './AccommodationItem.module.scss';

interface AccommodationItemInfoProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  item: AccommodationItemType;
  disabled?: boolean;
  loading?: boolean;
  onAdd?: () => void;
}

const AccommodationItemInfo: FC<AccommodationItemInfoProps> = props => {
  const { item, disabled, loading, className, onAdd } = props;
  const { translate } = useTranslate();

  return (
    <div className={classNames(className, styles.itemBody, 'align-items-sm-center')}>
      <div className={styles.content}>
        <div className={styles.title}>{item.name}</div>
        {item.info && <div>{item.info}</div>}
        <div className="d-flex" style={{ gap: 8 }}>
          {!!item.numberOfBeds && item.numberOfBeds > 0 && (
            <Tooltip title={String(translate('accommodation.numberOfBeds'))}>
              {item.numberOfBeds}&times; <Hotel size={30} />
            </Tooltip>
          )}
          {item.hasDrain && (
            <Tooltip title={String(translate('accommodation.hasDrain'))}>
              <IconDrop />
            </Tooltip>
          )}
          {item.hasElectricity && (
            <Tooltip title={String(translate('accommodation.hasElectricity'))}>
              <IconPlug />
            </Tooltip>
          )}
        </div>
      </div>
      <div className="d-flex align-items-center flex-shrink-0" style={{ gap: 16 }}>
        {item.available ? (
          <>
            <FormattedCurrency
              value={item.pricing.sellPrice}
              name={item.currency.name}
              className={styles.price}
            />
            {onAdd && (
              <Button
                primary
                outline
                onClick={onAdd}
                loading={loading}
                disabled={disabled || loading}
              >
                <IconPlus size={24} /> {String(translate('accommodation.addToCart'))}
              </Button>
            )}
          </>
        ) : (
          <div>{String(translate('accommodation.notAvailableForDates'))}</div>
        )}
      </div>
    </div>
  );
};

export default AccommodationItemInfo;
